import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSite } from "hooks/use-site";
import { detectCountry, isCzechRegion, setLanguage } from "locales/i18n";

const AuthLanguageSelector = () => {
  const { multilanguage } = useSite();
  const { i18n } = useTranslation();
  const [czechAvailable, setCzechAvailable] = useState(false);

  useEffect(() => {
    if (!multilanguage) {
      setCzechAvailable(false);
      return;
    }

    let cancelled = false;
    detectCountry().then((country) => {
      if (!cancelled) {
        setCzechAvailable(isCzechRegion(country));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [multilanguage]);

  if (!multilanguage || !czechAvailable) {
    return null;
  }

  const currentLang = i18n.language?.startsWith("cs") ? "cs" : "en";

  const handleChange = (event: SelectChangeEvent) => {
    setLanguage(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 88 }}>
      <Select
        value={currentLang}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Language" }}
        sx={{
          bgcolor: "background.paper",
          "& .MuiSelect-select": { py: 0.75, px: 1.5 },
        }}
      >
        <MenuItem value="en">EN</MenuItem>
        <MenuItem value="cs">CZ</MenuItem>
      </Select>
    </FormControl>
  );
};

export default AuthLanguageSelector;
